import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  // scrollBehavior(){
  //   return {x: 0, y: 0};
  // },
  // scrollBehavior (to, from, savedPosition) {
  //   return { x: 0, y: 0}
  // },
  linkExactActiveClass: 'ag-nav-active',
  routes: [
    {
      path: '/',
      name: 'home',
      redirect: "/index"
    },
    {
      path: '/index',
      name: 'index',
      component: () => import('./views/index/index.vue')
    },
    {
      path: "/product",
      name: "product",
      component: () => import('./views/Product/Index.vue')
    },
    {
      path: "/case",
      name: "case",
      component: () => import('./views/Case/Index.vue')
    },
    {
      path: "/flow",
      name: "flow",
      component: () => import('./views/Flow/Index.vue')
    },
    {
      path: "/flux2",
      name: "flux2",
      component: () => import('./views/Flow/Flux2.vue')
    },
    {
      path: "/flux3",
      name: "flux3",
      component: () => import('./views/Flow/Flux3.vue')
    },
    // {
    //   path: '/about',
    //   name: 'about',
    //   component: () => import('./views/About/Index_2.vue')
    // },
    {
      path: '/we',
      name: 'we',
      component: () => import('./views/We/Index.vue')
    },
    {
      name: '404',
      path: '/404',
      component: () => import('./views/404.vue')
    },
    {
      path: '*',
      redirect: '/404'
    }
  ],
  // scrollBehavior (to, from, savedPosition) {
  //     return { x: 0, y: 0 }
  // }
})
